/**
 * Product Preview Modal
 *
 * Listens for Bootstrap's show.bs.modal event on #rr-product-preview-modal
 * and populates it from data attributes on the triggering button.
 *
 * Trigger contract — add these data attributes to any button:
 *   data-bs-toggle="modal"
 *   data-bs-target="#rr-product-preview-modal"
 *   data-preview-title       — product title (plain text)
 *   data-preview-image       — featured image URL
 *   data-preview-description — full description (HTML allowed)
 *   data-preview-url         — product page URL
 *   data-preview-price-id    — Shopify product ID used to read the
 *                              already-loaded [data-price-for] element
 */

(function () {
  const MODAL_ID = 'rr-product-preview-modal';

  const SELECTORS = {
    image: '#rr-product-preview-image',
    title: '#productPreviewModalLabel',
    price: '#rr-product-preview-price',
    description: '#rr-product-preview-description',
    link: '#rr-product-preview-link',
  };

  function getLoadedPrice(productId) {
    if (!productId) return null;
    const el = document.querySelector(`[data-price-for="${productId}"]`);
    if (!el) return null;
    const text = el.textContent.trim();
    return text && text !== 'Loading...' ? text : null;
  }

  function populateModal(trigger) {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    const title = trigger.dataset.previewTitle || '';
    const imageUrl = trigger.dataset.previewImage || '';
    const description = trigger.dataset.previewDescription || '';
    const url = trigger.dataset.previewUrl || '#';
    const priceId = trigger.dataset.previewPriceId || '';

    const imageEl = modal.querySelector(SELECTORS.image);
    const titleEl = modal.querySelector(SELECTORS.title);
    const priceEl = modal.querySelector(SELECTORS.price);
    const descEl = modal.querySelector(SELECTORS.description);
    const linkEl = modal.querySelector(SELECTORS.link);

    if (imageEl) {
      imageEl.src = imageUrl;
      imageEl.alt = title;
    }

    if (titleEl) {
      titleEl.textContent = title;
    }

    if (priceEl) {
      const loadedPrice = getLoadedPrice(priceId);
      if (loadedPrice) {
        priceEl.textContent = loadedPrice;
        priceEl.classList.remove('placeholder-glow');
      } else {
        priceEl.classList.add('placeholder-glow');
        priceEl.innerHTML = '<span class="placeholder col-4"></span>';
      }
    }

    if (descEl) {
      descEl.innerHTML = description;
    }

    if (linkEl) {
      linkEl.href = url;
    }
  }

  function clearModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    const imageEl = modal.querySelector(SELECTORS.image);
    const titleEl = modal.querySelector(SELECTORS.title);
    const priceEl = modal.querySelector(SELECTORS.price);
    const descEl = modal.querySelector(SELECTORS.description);
    const linkEl = modal.querySelector(SELECTORS.link);

    if (imageEl) { imageEl.src = ''; imageEl.alt = ''; }
    if (titleEl) { titleEl.textContent = ''; }
    if (priceEl) {
      priceEl.classList.add('placeholder-glow');
      priceEl.innerHTML = '<span class="placeholder col-4"></span>';
    }
    if (descEl) { descEl.innerHTML = ''; }
    if (linkEl) { linkEl.href = '#'; }
  }

  function init() {
    const modalEl = document.getElementById(MODAL_ID);
    if (!modalEl) return;

    modalEl.addEventListener('show.bs.modal', function (event) {
      const trigger = event.relatedTarget;
      if (trigger) {
        populateModal(trigger);
      }
    });

    modalEl.addEventListener('hidden.bs.modal', clearModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
